const NOTIFICATION = 'NOTIFICATION';
export const NOTIFICATION_DISPLAY = `${NOTIFICATION}_DISPLAY`;
export const DISMISS = `${NOTIFICATION}_DISMISS`;
